import type { IFilterValue } from 'entities/Contacts/api/filterTypes.ts'
import { type FilterItem } from 'widgets/FilterEditor/model'

export const MultiRecurringTypeKeys = new Set(['broadcasts_recurring_settings.type'])

export const isMultiRecurringTypeWidget = <T extends IFilterValue, C>(
  filterItem: FilterItem<T, C>
) => MultiRecurringTypeKeys.has(filterItem.key)
